<template>
  <div
    class="v-view chart-view a-fadeIn"
    :style="{ height: span * 33.33 + '%' }"
  >
    <div class="v-title">{{ title }}</div>

    <div class="line-charts">
      <v-chart
        v-if="lineData.length > 0"
        class="cv-chart"
        :options="lineOption"
        autoresize
      ></v-chart>
      <div v-else class="nodata">
        <img src="../assets/images/no-data.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import PubSub from "pubsub-js";
export default {
  name: "JCline",
  computed: {},
  props: {
    type: {
      type: String,
      default: "line",
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: "近六个月应急报警工单趋势",
    },
  },
  watch: {},
  data() {
    return {
      lineData: [1],
      lineOption: {
        grid: {
          top: "40",
          left: "2%",
          right: "4%",
          bottom: "10",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#ffebe0",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            fontSize: 14,
            color: "#fff",
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              color: "#ffebe0",
            },
          },
          axisLabel: {
            fontSize: 14,
            color: "#fff",
          },
          splitLine: {
            show: true,
            lineStyle: {
              opacity: 0.3,
              type: "dashed",
            },
          },
        },
        legend: {
          show: true,
          top: "top",
          left: "center",
          itemGap: 50,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: "axis",
        },
        dataset: {
          source: [
            {
              month: "6月",
              house: "221",
            },
            {
              month: "7月",
              house: "342",
            },
            {
              month: "8月",
              house: "483",
            },
            {
              month: "9月",
              house: "563",
            },
            {
              month: "10月",
              house: "876",
            },
            {
              month: "11月",
              house: "634",
            },
            {
              month: "12月",
              house: "234",
            },
          ],
        },
        series: [
          {
            type: "line",
            // name: '居家上门服务',
            symbolSize: 5,
            label: {
              show: true,
              position: "top",
              distance: 8,
              fontSize: 14,
              color: "#ff2538",
              formatter: (params) => {
                const { value } = params;
                return value.house;
              },
            },
            itemStyle: {
              color: "#ff2538",
            },
            lineStyle: {
              color: "#ff2538",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,37,56,0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255,37,56,0)",
                  },
                ],
                global: false,
              },
              shadowBlur: 10,
              shadowColor: "rgba(255,37,56,0.8)",
            },
            encode: {
              x: "month",
              y: "house",
              tooltip: "house",
            },
          },
        ],
      },
    };
  },
  watch: {},
  mounted() {
    this.CountAccidentByMonth();
  },
  methods: {
    CountAccidentByMonth() {
      this.$api
        .CountAccidentByMonth()
        .then((data) => {
          if (!data) return;
          this.lineData = data;
          this.lineOption.dataset.source = data.map((item) => {
            let newData = {
              month: item.month + "月",
              house: item.count,
            };
            return newData;
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.line-charts {
  width: 100%;
  height: 100%;
}

.cv-chart {
  width: 100%;
}
</style>